import { AbstractSearchCriteria } from './abstract-search-criteria';

export class RoutesSearchCriteria extends AbstractSearchCriteria {
    code: string;
    fromGroupCode: string;
    toGroupCode: string;
}
